// ============================================================================
// API Configuration
// ============================================================================

export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_API_URL || "http://localhost:3001",
  TIMEOUT: 10000,
} as const;

// ============================================================================
// Navigation
// ============================================================================

export const NAV_LINKS = [
  { href: "/strategies", label: "Strategies" },
  { href: "/trade", label: "Trade" },
  { href: "/portfolio", label: "Portfolio" },
  { href: "/accounts", label: "Accounts" },
];

export const FOOTER_LINKS = [
  { href: "/privacy", label: "Privacy Policy" },
  { href: "/terms", label: "Terms of Service" },
  { href: "/docs", label: "Documentation" },
];

export const ROUTE_PAGE_NAMES: Record<string, string> = {
  "/": "homepage",
  "/strategies": "strategies",
  "/trade": "trade",
  "/portfolio": "portfolio",
  "/accounts": "accounts",
  "/settings": "settings",
  "/privacy": "privacy",
  "/terms": "terms",
  "/docs": "docs",
};
